export default __webpack_public_path__ + "static/media/33.9c3184b2.jpg";